import { ref, computed } from "vue";
import { useNuxtApp } from "#app";
export function useCheckoutData(orderStatements) {
  const { $auth } = useNuxtApp();
  const billingAddress = ref({});
  const deliveryData = ref({});
  const totalPrice = computed(() => {
    return orderStatements.value.map((statement) => statement.amount).reduce((a, b) => a + b, 0);
  });
  const isFree = computed(() => {
    return totalPrice.value <= 0;
  });
  function initializeDeliveryData(defaultData = {}) {
    if (Object.keys(deliveryData.value).length) {
      return deliveryData.value;
    }
    if ($auth.user) {
      deliveryData.value = {
        name: `${$auth.user.first_name} ${$auth.user.last_name}`,
        country_code: $auth.user.country_code,
        state_code: $auth.user.state_code,
        postcode: $auth.user.postcode,
        city: $auth.user.city,
        street: $auth.user.street
      };
      return;
    } else {
      deliveryData.value = defaultData;
    }
    return deliveryData.value;
  }
  function initializeBillingAddress(defaultData = {}) {
    if (Object.keys(billingAddress.value).length) {
      return billingAddress.value;
    }
    if (Object.keys(deliveryData.value).length) {
      billingAddress.value = { ...deliveryData.value, company: deliveryData.value.co_name ?? defaultData.company, email: $auth.user ? $auth.user.email : defaultData.email };
      return billingAddress.value;
    }
    if ($auth.user) {
      billingAddress.value = {
        name: `${$auth.user.first_name} ${$auth.user.last_name}`,
        country_code: $auth.user.country_code,
        state_code: $auth.user.state_code,
        postcode: $auth.user.postcode,
        city: $auth.user.city,
        street: $auth.user.street,
        email: $auth.user.email
      };
      return;
    } else {
      billingAddress.value = defaultData;
    }
    return billingAddress.value;
  }
  return {
    billingAddress,
    deliveryData,
    totalPrice,
    isFree,
    initializeDeliveryData,
    initializeBillingAddress
  };
}
